import { useMemo } from "react";
import { useQuery, keepPreviousData } from "@tanstack/react-query";
import { listConversations } from "@/lib/api";
import { queryKeys } from "@/lib/cache/queryKeys";
import { staleTimes } from "@/lib/cache/staleTimes";

export function useConversations({
  caseId = null,
  researchSessionId = null,
  documentId = null,
  documentIds = null,
  includeMessages = false,
} = {}) {
  const filters = useMemo(
    () => ({
      caseId: caseId || null,
      researchSessionId: researchSessionId || null,
      documentId: documentId || null,
      documentIds: documentIds?.length ? [...documentIds].sort().join(",") : null,
      includeMessages,
    }),
    [caseId, researchSessionId, documentId, documentIds, includeMessages],
  );

  return useQuery({
    queryKey: queryKeys.conversations(filters),
    queryFn: () =>
      listConversations({
        caseId: filters.caseId || undefined,
        researchSessionId: filters.researchSessionId || undefined,
        documentId: filters.documentId || undefined,
        documentIds: filters.documentIds ? filters.documentIds.split(",") : undefined,
        includeMessages: filters.includeMessages,
      }),
    staleTime: staleTimes.conversations,
    placeholderData: keepPreviousData,
  });
}
